export const openSwish = () => {
  window.location.href = 'swish://?target=_blank'
}
